/**
 * @file 首页页面底部使用引导
 * @description 在用户浏览完页面后再做一次引导
 */

import React from 'react'

import Button from 'components/UI/Button'

import styles from './style.less'

export default function UsageGuide() {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>共享闲置资源，获取现金收益</h3>
      <Button className={styles.btn} href="/cooperations#apply">立即参与</Button>
    </div>
  )
}
